import { useEffect } from 'react'
import { useLazyQuery } from '@apollo/client/react'
import { Button } from '@/atoms/Button'
import { DownloadIcon } from '@/atoms/Icons/DownloadIcon'
import { ParagraphSM } from '@/atoms/Text'
import { GetSignedPdfUrlQuery } from '@/types/codegen-federation'
import { useTranslate } from '@/utils/translate/translate-client'
import { useTorchApplication } from '../../components/TorchApplicationContext'
import { GET_SIGNED_PDF_URL } from '../../queries'

export const FilmmakerApplication = () => {
  const { t } = useTranslate('guild-create')
  const { data, id } = useTorchApplication()

  const [getSignedPdfUrl, { data: signedPdfData }] = useLazyQuery<GetSignedPdfUrlQuery>(GET_SIGNED_PDF_URL, {
    errorPolicy: 'all',
  })

  useEffect(() => {
    if (signedPdfData) {
      window.open(signedPdfData?.torchApplication?.signedPdfUrl ?? undefined, '_blank')
    }
  }, [signedPdfData])

  const handleDownload = () => {
    getSignedPdfUrl({ variables: { id } })
  }

  const signatureDate = data?.signatureDate ? new Date(data.signatureDate) : null

  return (
    <div className="mx-6">
      <ParagraphSM weight="bold">
        {t('signedElectronicallyOn', 'Signed electronically on')} {signatureDate?.toLocaleDateString()}{' '}
        {signatureDate?.toLocaleTimeString()}
      </ParagraphSM>

      <Button variant="lightgray" onClick={handleDownload} className="flex items-center justify-between gap-2">
        <DownloadIcon size={24} color="core-gray-800" />
        {t('download', 'Download')}
      </Button>
    </div>
  )
}
